import $ from 'jquery'

$(".reject__modal-toggle").on('click', function() {
  $(".reject__order").data("id", $(this).data("id"))
});

$(".order-card").each((_, card) => {
  const $card = $(card);
  const $images = $card.find(".order__images");
  const $items = $images.find(".order__images-item");

  if ($items.length > 9 && !$images.hasClass('slick-initialized')) {
    $images.slick({
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 9.5,
      slidesToScroll: 1,
      arrows: true,
      nextArrow: `
        <svg class="slick-next-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M17.7778 15.5554L22.2222 19.9999L17.7778 24.4443" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
      prevArrow: `
        <svg class="slick-prev-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#FAFAFA" stroke="#E4E4E4"/>
          <path d="M22.2222 24.4446L17.7778 20.0001L22.2222 15.5557" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
    });
  }
});


function changeOrderStatus() {
    const orderId = $(this).data("id");
    const _token = $("input[name='_token']").val();
    const comment = $("#comment")

    const formData = new FormData();

    formData.append("status", $(this).data("status"));
    formData.append("_method", "PATCH");
    formData.append("_token", _token);
    if(comment) {
      formData.append("status_comment", comment?.val());
    }

    fetch(`/order/${orderId}`, {
      method: "POST",
      body: formData,
    }).then(() => {
      location.reload();
      if(comment) {
        comment.val('')
      }
    });
}

$(".publicate__order").on("click", changeOrderStatus);

$(".reject__order").on("click", changeOrderStatus);

